<script>
    import {createEventDispatcher} from "svelte";
    import {I_DEAL, I_COMPANY} from "../../../../../lib/datatypes";
    import {fullNameFromRawPerson} from "../stores/misc";
    import {now, toDate, getTimeDiffAsShortText} from "../../../../../lib/dates_times";
    import {companies} from "../stores/companies";
    import Label from "./Label.svelte";
    import SmallNextAction from "./SmallNextAction.svelte";

    const dispatch = createEventDispatcher();
    export let deals_arr_list;

    const onItemClicked = id => {
        dispatch('dealClicked', {id:id});
    }
</script>


<table class="min-w-full divide-y divide-gray-300">
<!--    <thead>-->
<!--    <tr>-->
<!--        <th scope="col" class="py-3.5 pl-0 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>-->
<!--        <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Last Name</th>-->
<!--        <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">Position</th>-->
<!--        <th scope="col" class="relative py-3.5 pl-3 pr-0 text-left text-sm font-semibold text-gray-900 sm:pr-6">Company</th>-->
<!--    </tr>-->
<!--    </thead>-->
    <tbody class="divide-y divide-gray-200 bg-white">
    {#each deals_arr_list as deal_arr (deal_arr[I_DEAL.ID])}
        <tr data-id="{deal_arr[I_DEAL.ID]}" on:click={() => onItemClicked(deal_arr[I_DEAL.ID])}
            class="cursor-pointer">
            <td class="w-1/3 max-w-0 py-4 pl-0 pr-3 text-sm text-gray-700 align-top sm:w-auto sm:max-w-none sm:pl-6">
                <span class="inline-flex align-text-bottom"><Label type={'company'}></Label></span>
                {$companies.lookup[deal_arr[I_DEAL.ID_COMPANY]][I_COMPANY.NAME]}
                <dl class="font-normal lg:hidden">
                    <dt class="sr-only">Updated</dt>
                    <dd class="mt-1 text-gray-400">
                        <time datetime="{deal_arr[I_DEAL.UPDATED]}" title="{deal_arr[I_DEAL.UPDATED]}">{getTimeDiffAsShortText(now().valueOf() - toDate(deal_arr[I_DEAL.UPDATED]))}</time>
                    </dd>
                </dl>
            </td>
            <td class="hidden px-3 py-4 text-sm text-gray-500 align-top lg:table-cell">
                <time datetime="{deal_arr[I_DEAL.UPDATED]}" title="{deal_arr[I_DEAL.UPDATED]}">{getTimeDiffAsShortText(now().valueOf() - toDate(deal_arr[I_DEAL.UPDATED]))}</time>
            </td>
<!--            <td class="hidden px-3 py-4 text-sm text-gray-500 align-top sm:table-cell">{$additional_companies_info[deal_arr[I_DEAL.ID]][0].position}</td>-->
            <td class="w-2/3 sm:w-auto py-4 pl-3 pr-6 align-top sm:pr-0">
                <p class="text font-medium text-gray-800 mb-2">{@html deal_arr[I_DEAL.TITLE]}</p>
                <SmallNextAction next_action={deal_arr[I_DEAL.NEXT_ACTION]}></SmallNextAction>
            </td>
        </tr>
    {:else}
        <tr><td class="text font-medium italic text-gray-400 py-4">No Deals</td></tr>
    {/each}
    </tbody>
</table>


<style></style>